import { all, takeLatest } from 'typed-redux-saga'

/* ------------- Sagas ------------- */
import {
	createBankLoginUrlSaga,
	clearStateSaga,
} from './consumerDataPullSessionSagas/bankLoginSagas'
import {
	createBankSessionSaga,
	createBankSessionSucceededSaga,
	getAllBankSessionsSaga,
} from './consumerDataPullSessionSagas/bankSessionSagas'
import { createPsd2ConsentSaga } from './consumerDataPullSessionSagas/psd2ConsentSagas'
import { authenticateWithSessionIdSaga } from './consumerDataPullSessionSagas/authenticateSagas'
import {
	closeConsumerDataPullSessionSaga,
	reopenConsumeSessionSaga,
} from './consumerDataPullSessionSagas/consumerSessionDataSagas'
import {
	storeRedirectWindowApplicantId,
	clearRedirectWindowApplicantId,
} from './redirectWindowSagas'
import { fetchBankSessionsTransactions } from './consumerDataPullSessionSagas/bankTransactionSagas'
import {
	signalRConnect,
	consentGivenSaga,
	consentSucceededSaga,
} from './signalRSagas'

/* ------------- Connect Types To Sagas ------------- */
export default function* root() {
	yield all([
		takeLatest(
			'transactionClientApp/consumerPullSessions/close',
			closeConsumerDataPullSessionSaga,
		),
		takeLatest('CREATE_BANK_LOGIN_URL', createBankLoginUrlSaga),
		takeLatest(reopenConsumeSessionSaga.pattern, reopenConsumeSessionSaga),
		takeLatest(
			'transactionClientApp/authenticate/withSessionId',
			authenticateWithSessionIdSaga,
		),
		takeLatest(
			'transactionClientApp/bankSessions/create',
			createBankSessionSaga,
		),
		takeLatest(
			'transactionClientApp/bankSessions/createSucceeded',
			createBankSessionSucceededSaga,
		),
		takeLatest(
			'transactionClientApp/bankSessions/getAll',
			getAllBankSessionsSaga,
		),
		takeLatest('BANK_LOGIN_CLEAR_STATE', clearStateSaga),
		takeLatest(
			'STORE_REDIRECT_WINDOW_APPLICANT_ID',
			storeRedirectWindowApplicantId,
		),
		takeLatest(
			'CLEAR_REDIRECT_WINDOW_APPLICANT_ID',
			clearRedirectWindowApplicantId,
		),
		takeLatest(
			'transactionClientApp/fetchBankSessionsTransactions',
			fetchBankSessionsTransactions,
		),
		takeLatest(
			'transactionClientApp/psd2Consent/create',
			createPsd2ConsentSaga,
		),
		takeLatest(
			'transactionClientApp/psd2Consent/setPsd2ConsentGiven',
			consentGivenSaga,
		),
		takeLatest(
			'transactionClientApp/psd2Consent/createSucceeded',
			consentSucceededSaga,
		),
		takeLatest('transactionClientApp/signalR/connect', signalRConnect),
	])
}
